import ReactPixel from 'react-facebook-pixel';
import { PIXEL_ID } from 'core/utilities';

export const initPixelTracking = () => 
{

    const advancedMatching = undefined; // { em: 'some@email.com' } - optional, more info: https://developers.facebook.com/docs/facebook-pixel/advanced/advanced-matching

    const options = {
        autoConfig: true, // set pixel's autoConfig. More info: https://developers.facebook.com/docs/facebook-pixel/advanced/
        debug: false, // enable logs
    };

    ReactPixel.init(`${PIXEL_ID}`, advancedMatching, options);

    ReactPixel.pageView(); // For tracking page view
};